import PropTypes from 'prop-types'
import cn from '../modules/cn'
import Clickable from './Clickable'
import WithAddon from './WithAddon'

function Badge({
  children,
  onClick,
  to,
  href,
  leadingAddon,
  trailingAddon,
  addonProps,
  className,
}) {
  const wrapperStyle = cn(
    'px-1.5 flex items-center rounded outline-none bg-gray-400 text-white focus:outline-none inline-block',
    // The text-base here is so the addon font size depending on 1.25em is based on the base font size (16px).
    // The align-middle is in place to align a badge vertically centered when it's placed in a bigger context
    // like <Heading />.
    'text-base align-middle',
    (onClick || to || href) && 'hover:bg-gray-900',
    className,
  )

  const props = {
    leadingAddon,
    trailingAddon,
    wrapperClassName: 'space-x-1',
    className: 'text-xxs tracking-widest font-extrabold uppercase leading-6',
    leadingAddonClassName: 'text-[1.25em]',
    trailingAddonClassName: 'text-[1.25em]',
    children,
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    ...addonProps,
  }

  return (onClick || to || href) ? (
    <Clickable
      className={wrapperStyle}
      onClick={onClick}
      to={to}
      href={href}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <WithAddon {...props} />
    </Clickable>
  ) : (
    <div className={wrapperStyle}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <WithAddon {...props} />
    </div>
  )
}

Badge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
  })]),
  href: PropTypes.string,
  leadingAddon: PropTypes.node,
  trailingAddon: PropTypes.node,
  addonProps: PropTypes.shape(WithAddon.propTypes),
  className: cn.propType,
}

Badge.defaultProps = {
  children: null,
  onClick: null,
  to: null,
  href: null,
  leadingAddon: null,
  trailingAddon: null,
  addonProps: null,
  className: null,
}

export default Badge
